export default __webpack_public_path__ + "static/media/timeCard.ef87c12b.png";